import { render, staticRenderFns } from "./wlIndex.vue?vue&type=template&id=17e86966&scoped=true&"
import script from "./wlIndex.vue?vue&type=script&lang=js&"
export * from "./wlIndex.vue?vue&type=script&lang=js&"
import style0 from "./wlIndex.vue?vue&type=style&index=0&id=17e86966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e86966",
  null
  
)

export default component.exports